// extracted by mini-css-extract-plugin
export var actionIcon = "SquareCard-module--actionIcon--2t97w";
export var body = "SquareCard-module--body--2HSgR";
export var bxTextTruncateEnd = "SquareCard-module--bx--text-truncate--end--1NF4q";
export var bxTextTruncateFront = "SquareCard-module--bx--text-truncate--front--2IvVW";
export var darkMode = "SquareCard-module--darkMode--3o9cc";
export var disabled = "SquareCard-module--disabled--22Tsd";
export var helperIcon = "SquareCard-module--helperIcon--1URrf";
export var helperText = "SquareCard-module--helperText--2noas";
export var squareCard = "SquareCard-module--squareCard--1EQJx";
export var title = "SquareCard-module--title--38nbl";
export var titleSmall = "SquareCard-module--titleSmall--34rgq";